import React, { ReactNode } from 'react';

import { ReactComponent as SpinnerIcon } from '../../assets/spinner.svg';
import {
	container as containerStyle,
	error as errorStyle,
	spinner as spinnerStyle,
} from './style.module.css';

interface LoadingSpinnerProps {
	error?: Error;
	loading?: boolean;
	data?: any;
	children?: ReactNode;
	scale?: number;
}

export const LoadingSpinner = ({
	error,
	loading,
	data,
	children,
	scale,
}: LoadingSpinnerProps): JSX.Element => {
	return (
		<>
			{loading && (
				<div className={containerStyle}>
					<SpinnerIcon
						className={spinnerStyle}
						style={{ ...(scale ? { transform: `scale(${scale})` } : {}) }}
					/>
				</div>
			)}
			{!!error && <div className={errorStyle}>{error.message}</div>}
			{!!data && !loading && children}
		</>
	);
};
